export default __webpack_public_path__ + "static/media/castle1.7556640c.jpg";